export const MAX_FILE_ATTACHMENT_SIZE_BYTES = 20 * 1024 * 1024;

export const ALLOWED_FILE_EXTENSIONS = [
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".heic",
  ".heif",
  ".webp",
  ".docx",
  ".xlsx",
  ".csv",
  ".txt",
] as const;
